<div class="row g-3">
  <div class="col col-12">
    <h4 class="display-4">
      {{ 'add_on_features' | translate }}
    </h4>

    <hr class="m-0" />
  </div>

  <div class="col col-12">
    <div
      class="row g-3"
      [tds-data-loader]="{
        key: 'device-plan-features',
        class: 'col w-100 py-4',
        size: 'lg'
      }"
    >
      <div *ngFor="let feature of features; let i = index" class="col col-12">
        <div
          as-button
          stop-click-propagation
          class="card"
          [class.adjust-badge-height]="!sanitizedHTML(feature?.description)"
          [class.cursor-default]="feature.included"
          [class.last-feature]="i === features.length - 1"
          [class.active-card]="checkCartFeature(feature)"
          [class.elevate]="!checkCartFeature(feature)"
          [attr.aria-label]="feature.name_override ? feature.name_override : feature.name"
          (click)="feature.included ? $event.stopPropagation() : selectFeature(feature)"
        >
          <div class="card-body">
            <div class="row d-flex justify-content-between">
              <div class="col">
                <h5 class="line-clamp-2">
                  {{ feature.name_override ? feature.name_override : feature.name }}
                </h5>

                <small>
                  <button
                    stop-click-propagation
                    *ngIf="sanitizedHTML(feature?.description)"
                    class="btn btn-link neutral-btn text-capitalize fw-light text-decoration-underline focus-visible"
                    (click)="openDetailsModal(feature, feature.description)"
                  >
                    {{ 'view_details' | translate }}
                  </button>
                </small>
              </div>

              <div
                *ngIf="feature.cost_to_currency || feature.cost"
                class="col col-auto text-end d-flex"
              >
                <span *ngIf="feature.included" class="d-flex align-items-center me-4">
                  <ts-badge text="{{ 'included' | translate }}" />
                </span>

                <span>
                  <h5 class="my-0">
                    {{ feature.cost_to_currency || feature?.cost?.cost_to_currency }}
                  </h5>

                  <small class="text-secondary d-block">
                    {{ 'per_month' | translate }}
                  </small>
                </span>
              </div>
            </div>
          </div>

          <ts-admin-override-badge
            *ngIf="feature.admin"
            class="position-absolute bottom-0 end-0 border-top-left-radius"
          />
        </div>
      </div>

      <ng-template #defaultMessage>
        <div *ngIf="features.length === 0" class="col col-12">
          <div class="alert alert-primary" role="alert">
            {{ 'accessories_hint' | translate }}
          </div>
        </div>
      </ng-template>

      <div *ngIf="no_features; else defaultMessage" class="col col-12">
        <div class="alert alert-warning" role="alert">
          {{ 'features_no_results' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
